/**
 * League.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Main league shell.
 * Renders:
 *   1. Horizontal league selector (WSL, NWSL, Liga F …)
 *   2. The selected league's own component (which manages its own tabs)
 * ─────────────────────────────────────────────────────────────────────────────
 */

import { getLeagueById, DEFAULT_LEAGUE_ID } from '../data/leaguesNavData.js';
import {
    buildLeagueSelectorHTML,
    attachLeagueSelectorListeners,
    updateLeagueSelectorActive,
    leagueImageSrc
} from './league/LeagueSelector.js';
import { renderLeagueTabPanel } from './league/LeagueTabPlaceholders.js';

export class League {
    constructor(containerId, options = {}) {
        this.containerId      = containerId;
        this.selectedLeagueId = options.initialLeagueId || DEFAULT_LEAGUE_ID;
        this.root             = null;
    }

    getState() {
        return { leagueId: this.selectedLeagueId };
    }

    init() {
        this.root = document.getElementById(this.containerId);
        if (!this.root) return;
        this.render();
    }

    render() {
        this.root.innerHTML = `
            <div class="league-view" data-league-view>
                ${buildLeagueSelectorHTML(this.selectedLeagueId)}
                <div class="league-panel" data-league-panel aria-live="polite"></div>
            </div>
        `;

        this.syncPanel();

        attachLeagueSelectorListeners(this.root, (leagueId) => {
            this.selectedLeagueId = leagueId;
            updateLeagueSelectorActive(this.root, leagueId);
            const panel = this.root.querySelector('[data-league-panel]');
            if (panel) {
                const prev = panel.querySelector('[data-mounted]');
                if (prev) delete prev.dataset.mounted;
            }
            this.syncPanel();
        });
    }

    syncPanel() {
        const panel = this.root?.querySelector('[data-league-panel]');
        if (!panel) return;
        const league = getLeagueById(this.selectedLeagueId);
        panel.innerHTML = renderLeagueTabPanel('standings', league);
    }
}
